import React from "react"
import { BrandOperationKey, BrandOperationsState } from "../types"

interface BrandOperationsModalProps {
  isOpen: boolean
  onClose: () => void
  brandId: string
  operations: BrandOperationsState
  onOperationChange: (operation: BrandOperationKey, value: boolean) => void
}

const BrandOperationsModal: React.FC<BrandOperationsModalProps> = ({
  isOpen,
  onClose,
  brandId,
  operations,
  onOperationChange,
}) => {
  if (!isOpen) {
    return null
  }

  const operationLabels: Record<BrandOperationKey, string> = {
    meeting_planned: "Toplantı Planlandı",
    information_mail_sent: "Bilgilendirme Maili İletildi",
    directed_to_agency_based_work: "Ajans Bazlı Çalışmaya Yönlendirildi",
    demo_campaign_created: "Demo Kampanya Oluşturdu",
    balance_loaded: "Bakiye Yüklemesi Yapıldı",
    campaign_management_continues: "Kampanya Yönetim Süreci Devam Ediyor",
    campaign_completed: "Kampanya Tamamlandı",
    personal_account: "Kişisel Hesap",
  }

  return (
    <div className="fixed right-0 top-0 h-full z-50">
      <div className="bg-white h-full w-96 shadow-lg flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4">
          <div className="flex justify-between items-start">
            <div>
              <h2 className="text-xl font-semibold">Marka İşlemleri</h2>
              <p className="text-sm opacity-90 mt-1">Marka ID: {brandId}</p>
            </div>
            <button onClick={onClose} className="text-white hover:text-gray-200">
              ×
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 p-4 overflow-y-auto">
          <div className="space-y-4">
            {Object.entries(operationLabels).map(([key, label]) => (
              <label
                key={key}
                className="flex items-center space-x-3 cursor-pointer p-3 hover:bg-gray-50 rounded-md"
              >
                <input
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
                  checked={operations[key as keyof typeof operations]}
                  onChange={(e) => onOperationChange(key as BrandOperationKey, e.target.checked)}
                />
                <span className="text-gray-700 text-sm">{label}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="border-t p-4 bg-gray-50">
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-600">
              {Object.values(operations).filter(Boolean).length} işlem aktif
            </div>
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
              Kapat
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BrandOperationsModal
